import { SelectedAddons } from '../../state/types';

export type GroupedAddons = {
  [groupId: string]: {
    addonId: string;
    addon: SelectedAddons[string];
  }[];
};

export const groupSelectedAddonsByGroupId = (
  selectedAddons: SelectedAddons | undefined,
): GroupedAddons => {
  if (!selectedAddons) {
    return {};
  }

  return Object.entries(selectedAddons).reduce<GroupedAddons>(
    (groups, [addonId, addon]) => {
      const groupId = addon.groupId || 'default';
      if (!groups[groupId]) {
        groups[groupId] = [];
      }
      groups[groupId].push({
        addonId,
        addon,
      });
      return groups;
    },
    {},
  );
};
